import { updateState } from 'app-webtech-core/reducers/updateState';

// eslint-disable-next-line no-unused-vars
export const chatDialogsChatSoonHideReducer = (currentState, action) =>
  updateState(currentState, {
    showChatSoon: { $set: false },
    nextChatChannelId: { $set: null },
  });

export const chatDialogsChatSoonShowReducer = (currentState, action) =>
  updateState(currentState, {
    showChatSoon: { $set: true },
    nextChatChannelId: { $set: action.payload.channelId },
  });
